document.addEventListener('DOMContentLoaded', function() {
  initializeProductMultiTab();
});
 
function initializeAccordions(section) {
  const accordionItems = section.querySelectorAll('.accordion-item');
  
  accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-header');
    if (!header) return;

    const content = item.querySelector('.accordion-content');
    if (!content) return;

    header.addEventListener('click', function() {
      const isActive = item.classList.contains('active');
      
      Array.prototype.map.call(accordionItems, accordion => {
        accordion.classList.remove('active');
        accordion.querySelector('.accordion-content').style.maxHeight = null;
      });



      // Close all accordions
      // accordionItems.forEach(accordion => {
      //   accordion.classList.remove('active');
      //   const accordionContent = accordion.querySelector('.accordion-content');
      //   accordionContent.style.maxHeight = null;
      // });
      
      // Open clicked accordion if it wasn't already open
      if (!isActive) {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
}


function initializeProductMultiTab() {
  const sections = document.querySelectorAll('.bd-product-multi-tab');
  
  sections.forEach(section => {
    const tabItems = section.querySelectorAll('.tab-item');
    const tabContents = section.querySelectorAll('.tab-content');
    const sectionId = section.getAttribute('data-section-id');
    const storageKey = `bd-tab-${sectionId}`;
    
    // Initialize accordions
    initializeAccordions(section);
    
    tabItems.forEach(tabItem => {
      tabItem.addEventListener('click', function() {
        const tabIndex = this.getAttribute('data-tab-index');
        
        sessionStorage.setItem(storageKey, tabIndex);
        
        tabItems.forEach(item => item.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        
        this.classList.add('active');
        const activeContent = section.querySelector(`.tab-content[data-content-index="${tabIndex}"]`);
        if (activeContent) {
          activeContent.classList.add('active');
        }
      });
    });

      applyDesktopTabOverride(section, storageKey);
    
    const rangeSliders = section.querySelectorAll('.range-slider');
    
    rangeSliders.forEach(slider => {
      const tabContent = slider.closest('.tab-content');
      const nightImage = tabContent.querySelector('.night-image');
      if (!nightImage) return;

      const rangeHandle = slider.parentElement.querySelector('.range-handle');
      if (!rangeHandle) return;
      
      slider.addEventListener('input', function() {
        const sliderValue = this.value;
        const nightOpacity = sliderValue / 100;
        const handlePosition = sliderValue;
        
        nightImage.style.opacity = nightOpacity;
        rangeHandle.style.left = `${handlePosition}%`;
      });
    });
  });
}

document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.bd-product-multi-tab');
  if (!section) return;
  
  const sectionId = section.getAttribute('data-section-id');
  const saved = sessionStorage.getItem(`bd-tab-${sectionId}`);
  
if (saved && window.innerWidth > 768) {
    const tabItems = section.querySelectorAll('.tab-item');
    const tabContents = section.querySelectorAll('.tab-content');
    
    tabItems.forEach(item => item.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));
    
    const tab = section.querySelector(`[data-tab-index="${saved}"]`);
    const content = section.querySelector(`[data-content-index="${saved}"]`);
    
    if (tab && content) {
      tab.classList.add('active');
      content.classList.add('active');
    }
  }
  
  initializeProductMultiTab();
});


function applyDesktopTabOverride(section, storageKey) {
  const desktopHideTabs = section.querySelectorAll('.tab-item.bd-desktop-hide');
  const secondDesktopTab = section.querySelector('.tab-item:not(.bd-desktop-hide)');
  const desktopHideTabContents = section.querySelectorAll('.tab-content.bd-desktop-hide');
  const secondDesktopContent = section.querySelector('.tab-content:not(.bd-desktop-hide)');

  const mobileHideTabs = section.querySelectorAll('.tab-item.bd-mobile-hide');
  const secondMobileTab = section.querySelector('.tab-item:not(.bd-mobile-hide)');
  const mobileHideTabContents = section.querySelectorAll('.tab-content.bd-mobile-hide');
  const secondMobileContent = section.querySelector('.tab-content:not(.bd-mobile-hide)');

  const allTabs = section.querySelectorAll('.tab-item');
  const allContents = section.querySelectorAll('.tab-content');
  if (window.innerWidth > 768) {
    allTabs.forEach(t => t.classList.remove("active"));
    allContents.forEach(c => c.classList.remove("active"));

    if (secondDesktopTab) secondDesktopTab.classList.add("active");
    if (secondDesktopContent) secondDesktopContent.classList.add("active");

    sessionStorage.setItem(storageKey, "1");
  } else {
    // MOBILE — show first tab again

    // Remove desktop override
    sessionStorage.removeItem(storageKey);

    allTabs.forEach(t => t.classList.remove("active"));
    allContents.forEach(c => c.classList.remove("active"));

    if (secondMobileTab) secondMobileTab.classList.add("active");
    if (secondMobileContent) secondMobileContent.classList.add("active");

    // if (desktopHideTabs) desktopHideTabs.classList.add("active");
    // if (desktopHideTabContents) desktopHideTabContents.classList.add("active");
  }
}

let previousWidth = window.innerWidth;

window.addEventListener("resize", function () {
  const newWidth = window.innerWidth;
  if (newWidth !== previousWidth) {

    const sections = document.querySelectorAll('.bd-product-multi-tab');

    sections.forEach(section => {
      const sectionId = section.getAttribute('data-section-id');
      const storageKey = `bd-tab-${sectionId}`;

      sessionStorage.removeItem(storageKey);

      const allTabs = section.querySelectorAll('.tab-item');
      const allContents = section.querySelectorAll('.tab-content');

      allTabs.forEach(t => t.classList.remove("active"));
      allContents.forEach(c => c.classList.remove("active"));

      applyDesktopTabOverride(section, storageKey);
      
      previousWidth = newWidth;
    });
  }
});
